// AuthGuard.js
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom"; // Importe o Outlet

const AuthCheckToken = () => {// Você não precisa mais do { children }
  const accessToken = window.localStorage.getItem("accessToken");
  const location = useLocation();

  if (accessToken && ['/', '/sign-in', '/forgot-password', '/sign-up'].includes(location.pathname)) {
    window.location.href = '/app';
    return true;
  }

  return <Outlet />;

}

export default AuthCheckToken;